// extracted by mini-css-extract-plugin
module.exports = {"root":"_65d6b45","background":"_02f1f7c","tournamentName":"_a5414a0"};